export enum ActionTypes {
  REQUEST = "@auth/logoff/REQUEST",
  SUCCESS = "@auth/logoff/SUCCESS",
  FAILURE = "@auth/logoff/FAILURE",
}
